import "./styles.css";
import AboutPage from "./pages/main/portfolio/About/About";
import LandingPage from "./pages/main/portfolio/landingPage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignInForm from "./pages/main/portfolio/signin/signin";
import SignUpForm from "./pages/main/portfolio/Signup/signup";
import SignUpFormEmail from "./pages/main/portfolio/Signup/signupemail";
import Pricing from "./pages/main/portfolio/pricing/pricing";
import Contact from "./components/contact";
import Services from "./pages/main/portfolio/Services/services";
import Level from "./pages/main/portfolio/Level/Level";
import OTPScreen from "./pages/main/portfolio/Signup/OTPScreen";
import OTPSignInScreen from "./pages/main/portfolio/signin/OTPScreen";
import ProfileCreation from "./pages/main/portfolio/signin/Profile";
import Industury from "./pages/main/portfolio/signin/Industury";
import Final from "./pages/main/portfolio/signin/Final";
import IdentityVerify from "./pages/main/portfolio/signin/IdentityVerify";
import IdentityDoc from "./pages/main/portfolio/signin/IdentityDoc";
import UserDashboard from "./pages/Dashboard/UserDashboard";
import Main from "./pages/main/Views/Buisness/Main";
import AlertState from "./Context/Alert/AlertState";
import Alert from "./components/Alert";
import SocketState from "./Context/Socket/SocketState";
import { ThemeState } from "./Context/theme/ThemeState";
import UserState from "./Context/User/UserState";
import ForgotPassword from "./pages/main/portfolio/Signup/ForgotPassword";
import ResetPassword from "./pages/main/portfolio/Signup/ResetPassword";

function App() {
  return (
    <Router>
      <SocketState>
        <AlertState>
          <UserState>
            <ThemeState>
              <Alert />
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/level" element={<Level />} />
                <Route path="/services" element={<Services />} />
                <Route path="/signup" element={<SignInForm />} />
                <Route path="/signin" element={<SignUpForm />} />
                <Route path="/auth-verify-otp" element={<OTPSignInScreen />} />
                <Route
                  path="/profile-creation/:id"
                  element={<ProfileCreation />}
                />
                <Route path="/industry/:id" element={<Industury />} />
                <Route path="/verify/:id" element={<Final />} />
                <Route path="/verifictation/:id" element={<IdentityVerify />} />
                <Route path="/doc-verify/:id" element={<IdentityDoc />} />
                <Route path="/profileCreation/*" element={<Main />} /> 
                <Route path="/verify-otp" element={<OTPScreen />} />
                <Route path="/signinemail" element={<SignUpFormEmail />} />
                <Route path="/forgot_password" element={<ForgotPassword />} />
                <Route path="/reset_password" element={<ResetPassword />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/business" element={<Pricing />} />
                <Route path="/user-dashboard/*" element={<UserDashboard />} />
              </Routes>
            </ThemeState>
          </UserState>
        </AlertState>
      </SocketState>
    </Router>
  );
}

export default App;
